/** Relatórios (admin/owner). */
import { z } from "zod";

/* ---------- Relatório SLA ---------- */
export const slaReport = z.object({
  avgFirstResponseMinutes: z.number().nullable(),
  resolved: z.number().int(),
  open: z.number().int(),
  withinSlaPct: z.number().nullable(),
});
export type SlaReport = z.infer<typeof slaReport>;
